import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subject } from 'rxjs';

@Injectable()
export class UserInfoService {

  user = new Subject();
  isManager = new Subject();
  jwt = new JwtHelperService();

  constructor(private http: HttpService) { }

  getUserInfo(){
    const helper = new JwtHelperService();
    let token = localStorage.getItem('token');
    var userData = helper.decodeToken(token)
    // console.log(userData)
    this.user.next(userData);
  }

  getUserIdFromToken(){
      let token = localStorage.getItem('token');
      return new Promise((resolve, reject)=>{
        if(token){
          // console.log('22222222222222222222222222')
          //let data = this.jwt.decodeToken(token);
          resolve(this.jwt.decodeToken(token))
        }else{
          // console.log('SSSSSSSSSSSSSS')
          reject(false)
        }
    })
  }

  checkForBuildingManager(id){
    if(this.http.isLocalAuthenticated() === true) {
      this.http.isManagerExist(id).subscribe((data) => {
        this.isManager.next(false);
      }, (error) => {
        this.isManager.next(true);
      })
    }
  }

}
